<template>
    <div class="page-wework-combine">
        <content-title />
        <account-unbind
            v-if="showUnbind"
            :has-step-list="hasStepList"
        />
        <div v-else-if="currentState === 'main'">
            <tabs-router :has-sync="hasSync" />
        </div>
        <steps
            v-else-if="currentState"
            :step-key-list="stepKeyList"
            :step-key="currentState"
        />
    </div>
</template>

<script>
import Gateway from '@/utils/Gateway';
import { isPrivate } from 'src/config/private';
import ContentTitle from '../../content-title';
import AccountUnbind from '../../account-unbind';
import Steps from '../../steps';
import TabsRouter from '../../tabs-router';

export default {
    components: {
        ContentTitle,
        AccountUnbind,
        Steps,
        TabsRouter,
    },

    data() {
        return {
            // 当前流程步骤 main：主页|install_app：安装应用|authorize：绑定通讯录|sync：同步通讯录
            currentState: 'main',
            stepKeyList: [], // 有几个步骤，当前第几个，后台给
            hasSync: false, // 是否有同步通讯录步骤
            hasGetState: false,
            isPrivate,
        };
    },

    computed: {
        hasStepList() {
            return this.stepKeyList && this.stepKeyList.length > 0;
        },

        showUnbind() {
            return this.hasGetState && (this.currentState === 'guide' || !this.hasStepList);
        },
    },

    created() {
        // 这个接口 私有化环境不调用 需要将currentState置为main
        if (!this.isPrivate) {
            this.getFlowState();
        } else {
            this.currentState = 'main';
        }
        this.lamptipDataHandle();
    },

    methods: {
        getFlowState() {
            Gateway.get('/v1/basic/corp/wework/flowState')
                .then((data) => {
                    const { current, catalogue } = data || {};
                    this.stepKeyList = catalogue;

                    this.currentState = current;

                    if (this.stepKeyList.includes('sync')) {
                        this.hasSync = true;
                    }

                    this.hasGetState = true;
                })
                .catch((msg) => {
                    this.$message.error(msg || '获取企业状态失败');
                });
        },
        lamptipDataHandle() {
            // 兼容lamptip数据逻辑
            if (window.SSR_DATA && window.SSR_DATA.info && window.SSR_DATA.info.kfuin) {
                window.kf = {
                    uin: window.SSR_DATA.info.kfuin,
                };
            }
        },
    },
};
</script>
